import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { getFilesAsync } from '@platform/shared/utilities/upload-utility';

@Directive({
  selector: '[appDragAndDrop]',
})
// idea from: https://medium.com/@mariemchabeni/angular-7-drag-and-drop-simple-file-uploadin-in-less-than-5-minutes-d57eb010c0dc
export class DragAndDropDirective {
  @Input() dragAndDropEnabled = true;
  @Output() fileDragEnter = new EventEmitter();
  @Output() fileDragLeave = new EventEmitter();
  @Output() fileDropped = new EventEmitter<FileList>();
  @HostBinding('class.drag-over') dragOverEffect = false;

  target: any;

  @HostListener('dragenter', ['$event'])
  public onDragEnter(evt: any) {
    if (this.dragAndDropEnabled) {
      this.target = evt.target;
      evt.preventDefault();
      evt.stopPropagation();
      this.dragOverEffect = true;
      this.fileDragEnter.emit();
    }
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(evt: any) {
    if (this.dragAndDropEnabled) {
      evt.preventDefault();
      evt.stopPropagation();
      this.dragOverEffect = true;
    }
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt: any) {
    if (this.dragAndDropEnabled) {
      evt.preventDefault();
      evt.stopPropagation();
      if (this.target === evt.target) {
        this.dragOverEffect = false;
        this.fileDragLeave.emit();
      }
    }
  }

  @HostListener('drop', ['$event'])
  public async ondrop(evt: any) {
    if (this.dragAndDropEnabled) {
      evt.preventDefault();
      evt.stopPropagation();
      this.dragOverEffect = false;

      const files = await getFilesAsync(evt.dataTransfer);

      const dataTransfer = new DataTransfer();
      files.forEach((file) => dataTransfer.items.add(file));

      if (dataTransfer.files.length > 0) {
        this.fileDropped.emit(dataTransfer.files);
      }
    }
  }
}
